<template>
  <el-popover
    placement="top-start"
    width="500"
    trigger="hover"
    >
      <div class="todo todo-default">
      <div class="sm-avater list-avater">
        <img :src="avatar" class="img-responsive img-circle" alt="">
      </div>
      <h5 class="ct-title">{{ name }}
        <span class="ct-designation">{{ title }}</span>
        <span class="ct-designation"><i class="fa fa-envelope-o"></i> {{ userInfo.email }}</span>
        <span class="ct-designation"><i class="fa fa-phone"></i> {{ contact }}</span>
        <p v-if="userInfo.intro">{{ userInfo.intro }}</p>
      </h5>
      <div class="badge badge-action">
        <el-button type="primary" icon="fa fa-linkedin" circle></el-button>
      </div>
    </div>
    <img :src="avatar" class="img-responsive img-circle" alt="" slot="reference">
  </el-popover>
</template>
<style scoped>
  .todo.todo-default {
    border-bottom: none
  }
  span.ct-designation {
    margin-top: 5px;
  }
</style>
<script>
export default {
  name: 'Avatar',
  props: ['userId'],
  data: function() {
    return {
      userInfo: {
        'eName': null,
        'cName': null,
        'avatar': null,
        'cTitle': null,
        'eTitle': null,
        'mobile': null,
        'ext': null,
        'team': null,
        'email': null,
        'linkedin': null,
        'userType': null,
        'level': null,
        'sex': null,
        'intro': null
      }
    }
  },
  computed: {
    avatar: function() {
      if (this.userInfo.avatar)
        return this.STATIC_URL + 'avatar/' + this.userId + '.jpeg'
      else
        return '/img/avatar/no-avatar.png'
    },
    name: function() {
      if (this.userInfo.cName)
        return this.userInfo.eName + ' | ' + this.userInfo.cName
    },
    title: function() {
      let title = ''
      if (this.userInfo.eTitle)
        title += this.userInfo.eTitle
      if (this.userInfo.team)
        title += ' @' + this.getTeam(this.userInfo.team)

      return title
    },
    contact: function() {
      let contact = ''
      if (this.userInfo.mobile)
        contact += this.userInfo.mobile
      if (this.userInfo.ext)
        contact += ', ' + this.userInfo.ext

      return contact
    }
  },
  methods: {
    
  },
  created: function() {
    //init locations
    let that = this,
        query = 'profile' + '/' + this.userId
    this.$http.get(this.API3_PREFIX + query).then(function (response) {
      that.userInfo = response.data
    }).catch(function (error) {
    console.log(error)
    })
  }
}
</script>